export default __webpack_public_path__ + "static/media/ambassador_ondrej_svacina.56faf617.jpg";